import { NgModule } from 'ng-metadata/core';
import {SelectTextUtil} from './selectTextUtil';
import {MappingTablesCache} from '../mappingTablesCache/mappingTablesCache.service';
import {PrmText} from './primoText.directive';
import {RecordUtil} from './RecordUtil.service';
import {RestUtils} from './restUtils.service';
import {WidgetsModule} from './widgets/widgets.module';
import {HttpService} from './httpRequest/http.service';
import {MediaQueries} from './mediaQueries.service';
import {ChangeLangModule} from './lang/changeLang.module';
import {FormBuilderModule} from './formBuilder/formBuilder.module';
import {StorageUtil} from './storageUtil.service';
import {SharedSessionStorage} from "./sharedSessionStorage.service";
import {HighlightService} from "./highlight.service";
import {PrmDigestWhenInView} from "./digestWhenInView.directive";
import {PrmContextMenu} from "./prmContextMenu.directive"

@NgModule({
    declarations: [
        PrmText,
        PrmDigestWhenInView,
        PrmContextMenu
    ],
    providers: [
        HttpService,
        MappingTablesCache,
        MediaQueries,
        RecordUtil,
        RestUtils,
        SelectTextUtil,
        StorageUtil,
        SharedSessionStorage,
        HighlightService

    ],
    imports:[
        ChangeLangModule,
        FormBuilderModule,
        WidgetsModule
    ]
})

export class InfraMetadata{}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/infra-metadata.module.ts